import { SearchAdapter, TopRecommendationsRequest } from '@empathy/search-adapter';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { EmpathyXConfig, QueryOrigin } from '../../../models';
import { catchAdapterError, mapWishlistToResults } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { EMPATHIZE_ACTIONS_KEYS, EMPATHIZE_MUTATIONS_KEYS } from '../empathize.const';
import { EmpathizeAction, EmpathizeContext } from '../empathize.interfaces';

// TODO As the topclicked results shouldn't change in a session, we could get rid of this action, and use GetRecommendationsAction
export class GetResultsSuggestionsAction implements EmpathizeAction {
  private context: EmpathizeContext;
  actions = {
    [EMPATHIZE_ACTIONS_KEYS.getResultsSuggestions]: (context: EmpathizeContext): Promise<void> => {
      this.context = context;
      const { wishlist } = context.rootState.core;
      const searchAdapter = container.get<SearchAdapter>(DEPENDENCIES.Adapter);
      const recommendationsRequest: TopRecommendationsRequest = this.getSuggestionsRequest();
      return searchAdapter.getTopRecommendations(recommendationsRequest, { requestId: 'results-suggestions' })
        .then(response => {
          if (response) {
            mapWishlistToResults(wishlist, response.results);
            context.commit(EMPATHIZE_MUTATIONS_KEYS.saveEmpathizeResponse, { resultsSuggestions: response.results });
          }
        }).catch(catchAdapterError('Results suggestions'));
    }
  };

  private getSuggestionsRequest(): TopRecommendationsRequest {
    const { rootGetters } = this.context;
    const { resultsSuggestions }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
    return {
      rows: resultsSuggestions.size,
      origin: QueryOrigin.empathizeRecommendations
    };
  }
}
